import type { FilesUrlBase } from '@common/enums';
import { ViewerUrlQuery } from '@common/enums';

export function generateUrl(
    url?: string,
    id?: string,
    group?: string,
    urlBase?: FilesUrlBase,
    selectedFileIsPdf?: boolean,
    selectedFileId?: string
) {
    let newUrl: string;
    if ((!selectedFileIsPdf || !url) && (!urlBase || !selectedFileId)) {
        return;
    }

    if (selectedFileIsPdf && url) {
        newUrl = `/pdfViewer/web/viewer.html?file=${encodeURIComponent(url)}`;
    } else {
        newUrl = `/imageViewer?${ViewerUrlQuery.urlBase}=${urlBase}&${ViewerUrlQuery.selectedFileId}=${selectedFileId}`;

        if (id) {
            newUrl += `&id=${id}`;
        }

        if (group) {
            newUrl += `&${ViewerUrlQuery.group}=${group}`;
        }
    }

    return newUrl;
}
